<template>
  <main @touchmove.prevent>
    <div class='poster_wrap' v-if="isShowPoster">
      <div class="poster_box">
        <div class='advantage_tc'>
          <div class='advantage_img' @click="entoPosterDetail"><img v-lazy='imageUrl' /></div>
        </div>
        <div class="icon-small-wrp close_icon">
          <i class="iconfont icon-guanbi" @click="closePoster"></i>
        </div>
      </div>
      <template v-if="!isHomeTab">
        <div class='sh-dialog-mask' v-if="isUnClose"></div>
        <div class='sh-dialog-mask' @click="closePoster" v-else></div>
      </template>
    </div>
  </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config/index'
export default {
  data () {
    return {
      youpPath: IMG_BASE_URL,
      posterImg: '/upaiyun/Sys/20180710/4757627520439370268.png'
    }
  },
  props: {
    imageUrl: {
      type: String,
      default: '',
      required: true
    },
    isShowPoster: {
      type: Boolean,
      default: false,
      required: true
    },
    isUnClose: {
      type: Boolean,
      default: false
    },
    // 是否在有tab栏的页面展示弹窗
    isHomeTab: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    entoPosterDetail () {
      this.$emit('entoPosterDetail')
    },
    closePoster () {
      this.$emit('closePoster')
    }
  }
}
</script>

<style scoped>
   .poster_wrap{
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    width:100%;
    height: 100%;
    overflow:scroll;
    font-size:15px;
    z-index: 91;
  }
  .poster_box{
    position:absolute;
    width:70%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    z-index: 99;
  }
  .advantage_tc{
    width:100%;
    background: #fff;
    text-align: center;
    border-radius: 10px;
    z-index: 99;
    overflow: hidden;
  }
  .advantage_img img{
    width: 100%;
    display: block;
  }
  .advantage_txt p{
    display: block;
    font-size:16px;
    height: 24px;
  }
  .t_ff7f7e{
    color: #ff7f7e;
  }
  .btn_ff7ff3{
    position: relative;
    background: #ff7f7e;
    color: #fff;
    border-radius: 5px;
    height: 34px;
    line-height: 34px;
    width: 150px;
    margin:15px auto 0;
  }
  .btn_pd{
    padding-bottom: 20px;
  }
  .btn_ff7ff3 button{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .close_icon{
    text-align: center;
    margin-top: 10px;
    z-index: 99;
    color: #fff;
    position: relative;
  }
  .close_icon i{
    font-size: 28px;
  }
  .btn-hover-class{
    opacity: 0.8;
  }
</style>
